import { Collapse } from 'bootstrap'

document.addEventListener('DOMContentLoaded', () => {
  const { hash } = window.location
  if (!hash) return

  const id = hash.slice(1)
  const target = document.getElementById(id)
  if (!target) return

  const collapseEl = target.closest('.collapse')
  if (collapseEl && !collapseEl.classList.contains('show')) {
    new Collapse(collapseEl, { toggle: true })
  }

  target.scrollIntoView({ behavior: 'auto', block: 'start' })
})
